import {
    useMemo,
    useEffect
} from 'react'
import * as THREE from 'three'
import {
    windowBlindVertexShader,
    windowBlindFragmentShader,
    roomTextureVertexShader,
    roomTextureFragmentShader,
    musicVertexShader,
    musicFragmentShader,
} from '../shaders/ShaderManager.jsx'

export function useRoomMaterials(roomDayTexture, roomNightTexture, initialMixValue, stripeControls) {
    // Room shader material
    const roomMaterial = useMemo(() => {
        return new THREE.ShaderMaterial({
            uniforms: {
                uRoomDayTexture: {value: roomDayTexture},
                uRoomNightTexture: {value: roomNightTexture},
                uDayTimeMix: {value: initialMixValue}
            },
            vertexShader: roomTextureVertexShader,
            fragmentShader: roomTextureFragmentShader,
        })
    }, [roomDayTexture, roomNightTexture])

    // Stripe material for blinds
    const stripeMaterial = useMemo(() => {
        return new THREE.ShaderMaterial({
            uniforms: {
                uStripeCount: {value: 2},
                uStripeRatio: {value: 0.5},
                uOffset: {value: 0.2},
                uOpacity: {value: 0.5},
                uColor: {value: new THREE.Color('#ffffff')},
            },
            vertexShader: windowBlindVertexShader,
            fragmentShader: windowBlindFragmentShader,
            transparent: true,
            side: THREE.DoubleSide,
            depthWrite: false
        })
    }, [])

    const musicMaterial = useMemo(() => {
        return new THREE.ShaderMaterial({
            uniforms: {},
            vertexShader: musicVertexShader,
            fragmentShader: musicFragmentShader,
            side: THREE.DoubleSide,

        })
    }, [])

    // Update stripe material uniforms
    useEffect(() => {
        if (stripeMaterial && stripeMaterial.uniforms && stripeControls) {
            stripeMaterial.uniforms.uStripeCount.value = stripeControls.stripeCount
            stripeMaterial.uniforms.uStripeRatio.value = stripeControls.stripeRatio
            stripeMaterial.uniforms.uOffset.value = stripeControls.offset
            stripeMaterial.uniforms.uOpacity.value = stripeControls.opacity
            stripeMaterial.uniforms.uColor.value.set(stripeControls.color)
        }
    }, [stripeControls, stripeMaterial])

    return {roomMaterial, stripeMaterial, musicMaterial}
}